import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  // Button,
  Typography,
  // Box
} from '@mui/material';
import {
  AccountBalance as FinanceIcon,
  Message as MessageIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AdminActions = () => {
  const navigate = useNavigate();

  const actionItems = [
    {
      icon: FinanceIcon,
      label: 'Gestione Finanziaria',
      // description: 'Visualizza tutti i pagamenti e tesseramenti',
      color: 'primary.main',
      onClick: () => navigate('/admin/finance')
    },
    {
      icon: MessageIcon,
      label: 'Comunicazioni',
      // description: 'Invia comunicazioni agli utenti',
      color: 'secondary.main',
      onClick: () => navigate('/admin/communications')
    },
    {
      icon: AssessmentIcon,
      label: 'Reportistica',
      // description: 'Genera report e statistiche',
      color: 'success.main',
      onClick: () => navigate('/admin/reports')
    }
  ];

  return (
    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} sx={{ mb: { xs: 2, sm: 3, md: 4 }, justifyContent: 'center' }}>
      {actionItems.map((item, index) => (
        <Grid key={index} sx={{ display: 'flex', justifyContent: 'center' }} size={{ xs: 12, sm: 6, md: 4 }}>
          <Card
            onClick={item.onClick}
            sx={{
              height: '100%',
              minWidth: { xs: '100%', sm: 200, md: 260 },
              maxWidth: { xs: '100%', sm: 200, md: 260 },
              width: '100%',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4
              },
              borderRadius: 3
            }}
          >
            <CardContent sx={{ 
              textAlign: 'center', 
              py: { xs: 2, sm: 3, md: 4 },
              px: { xs: 1, sm: 2, md: 3 }
            }}>
              <item.icon sx={{ 
                fontSize: { xs: 40, sm: 50, md: 60 }, 
                color: item.color, 
                mb: { xs: 1, sm: 1.5, md: 2 } 
              }} />
              <Typography variant="h6" gutterBottom sx={{ 
                fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                mb: { xs: 0.5, sm: 1, md: 1 }
              }}>
                {item.label}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' }
              }}>
                {item.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AdminActions; 